import type { App } from 'vue'
import type { Router, RouterHistory } from 'vue-router'

import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router'

import { resetStaticRoutes } from '@vben/utils'

import { getMicroAppBaseRoute, isInMicroApp } from '#/micro-app'

import { createRouterGuard } from './guard'
import { routes } from './routes'

export * from './go'
export { accessRoutes } from './routes'

let history: RouterHistory

export let router: Router

export function setupRouter(app: App) {
  const baseRoute = isInMicroApp()
    ? getMicroAppBaseRoute()
    : import.meta.env.VITE_BASE
  console.log('baseRoute', baseRoute)

  history =
    import.meta.env.VITE_ROUTER_HISTORY === 'hash'
      ? createWebHashHistory(baseRoute)
      : createWebHistory(baseRoute)

  router = createRouter({
    history,
    // 应该添加到路由的初始路由列表。
    routes,
    scrollBehavior: (to, _from, savedPosition) => {
      if (savedPosition) {
        return savedPosition
      }
      return to.hash ? { behavior: 'smooth', el: to.hash } : { left: 0, top: 0 }
    },
    // 是否应该禁止尾部斜杠。
    // strict: true,
  })

  // 创建路由守卫
  createRouterGuard(router)

  app.use(router)
}

export function destroyRouter() {
  history?.destroy()
  // @ts-ignore xxx
  router = null
  // @ts-ignore xxx
  history = null
}

export const resetRoutes = () => resetStaticRoutes(router, routes)
